import { store } from '@utils/configStore'
import { articleManagementReducer } from './slice'

export const injectArticleManagementStore = () => store.injectReducer('articleManagement', articleManagementReducer)
